import { render, staticRenderFns } from "./PaymentForms.vue?vue&type=template&id=c32b77d2&"
import script from "./PaymentForms.vue?vue&type=script&lang=js&"
export * from "./PaymentForms.vue?vue&type=script&lang=js&"
import style0 from "./PaymentForms.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports